import { Fragment, FunctionalComponent, h } from 'preact';
import { Control, useController, UseControllerProps } from 'react-hook-form';
import { SliderImageStyled } from './slider-image.style';
export type SliderImageProps = {
  image: string;
};
export const SliderImage: FunctionalComponent<SliderImageProps> = (props) => {
  return <SliderImageStyled src={props.image} alt=''></SliderImageStyled>;
};
